module.exports = __webpack_public_path__ + "static/media/search.56362dc3.png";